import { html, nothing, TemplateResult } from 'lit';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';
import type { ConsentStore } from '@src/state/ConsentStore.js';
import { stripHtml } from '@src/util/helpers.js';

export function consentTemplateOverview(this: TefComs4csMicroFrontend, consent: ConsentStore): TemplateResult {
  const { featureTitlesAsString } = consent;
  return html`
    <one-cluster>
      <one-text as="div">${stripHtml(consent.shortScope!)}</one-text>
      ${featureTitlesAsString ? html`
        <one-text as="div" strong>${featureTitlesAsString}</one-text>
      ` : nothing}
    </one-cluster>
  `;
}
